import { createApiClient, createTokenStore } from '@fidalia/api';

import { env } from '@/env';

/**
 * Clé de stockage distincte de l'app admin : les deux interfaces cohabitent.
 *
 * `miroirCookie` recopie le jeton dans un cookie de même nom, à l'usage exclusif
 * de l'extension navigateur : c'est le seul moyen pour elle de savoir qui est
 * connecté sans onglet de l'app ouvert. L'app, elle, lit toujours le
 * `localStorage`.
 */
export const tokenStore = createTokenStore('fidalia.app.token', { miroirCookie: true });

export const apiClient = createApiClient({
  baseUrl: env.VITE_API_URL,
  tokens: tokenStore,
  onUnauthorized: (code) => {
    if (globalThis.location.pathname === '/login') return;

    // Le rechargement complet purge le cache React Query au passage : aucune
    // donnée du cabinet ne doit survivre à la coupure d'accès.
    const suffixe = code ? `?raison=${encodeURIComponent(code)}` : '';
    globalThis.location.assign(`/login${suffixe}`);
  },
});
